// extracted by mini-css-extract-plugin
export var action = "Pagination-module--action--a03cc";
export var active = "Pagination-module--active--b59e1";
export var altaccent = "Pagination-module--altaccent--6f13f";
export var container = "Pagination-module--container--e3431";
export var number = "Pagination-module--number--e2412";
export var pages = "Pagination-module--pages--70131";